module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMEAAACtBAMAAAD7WgaOAAAAJFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACmWAJHAAAAC3RSTlMAwfWwT0wYF/KIhYO9LaIAAACDSURBVHja7dY9CsJAFIXRF/EP7IRsRYtsxn24CXsbe6sEC+Ftzg3MVE4CgXPaW3ztDQAAAAAAlrM7Z8m3j1beWfGKNrZZ84k2urxEyX4Yo41N3qLoPkUbp6wOCgoKCgoKCgp/O87+Zrq8RslhGFfzKuOZFY+Z3/3UBwAAAAAAAADAon7nTpZZmGO4zQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yingJianImg2.png
// module id = z5Nq
// module chunks = 2